import React from 'react';
import CheckoutPage from '../components/CheckoutPage';

const Checkout = () => {
  return <CheckoutPage />;
};

export default Checkout;
